export default "__VITE_ASSET__CxR0sZ6u__"